module.exports = __webpack_public_path__ + "static/hero-c3d0eb53df635025ef2b0827ff51da76.gif";